import type { IAllProductSettingsResponse, ISettings } from '@/types'
import type { ISettingsGroup } from '@/types'

export const getAllProductSettings = async (
  accountId: string,
  productId: string,
): Promise<any | null> => {
  const endpoint = import.meta.env.VITE_PRODUCT_SETTINGS_API_URL
  const query = `product/config/${accountId}/${productId}`

  const response = await fetch(`${endpoint}${query}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  try {
    const responseJson: IAllProductSettingsResponse = await response.json()
    if (!response.ok) {
      throw new Error('Could not fetch products settings.')
    }

    return responseJson ?? null
  } catch (error) {
    return null
  }
}

export const addProduct = async (
  accountId: string,
  productId: string,
  initialConfig: any,
) => {
  const endpoint = import.meta.env.VITE_ADD_PRODUCT_API_URL

  await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': 'JeP08HSqFZ4wN0JdlmjLr58AiO63ImhS40FKTG9v',
    },
    body: JSON.stringify({
      event_type: 'AddProductToAccountRequest',
      event: {
        jazel_id: accountId,
        product_id: productId,
        config: initialConfig,
      },
    }),
  })
}

export const updateProductConfig = async (
  accountId: string,
  productId: string,
  newSettings: ISettings,
) => {
  const endpoint = import.meta.env.VITE_PRODUCT_SETTINGS_API_URL
  const query = `product/config/${accountId}/${productId}`
  await fetch(endpoint + query, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(newSettings),
  })
}

export const getVehicleStockCount = async () => {
  const endpoint = import.meta.env.VITE_VEHICLE_STOCK_API_URL
  // make sidebar = what we need to display the coutns of makes
  const query = `?q=((account_id:777))&q.parser=lucene&start=0&size=0&facet.make_sidebar={%27sort%27:%27bucket%27,%27size%27:10000}&facet.make_model_sidebar={%27sort%27:%27bucket%27,%27size%27:10000}`
  // model sidebar = what we neede to display counts of each individual models
  const response = await fetch(endpoint + query, {
    method: 'GET',
  })

  return response.json();
}

export const getAvailableYearsForFilters = async () => {
  const endpoint = 'https://gle1g0l5gh.execute-api.us-west-2.amazonaws.com/dev/'
  const response = await fetch(endpoint, {
    method: 'GET',
  })

  return response.json();
}

export const getAvailableMakesForFilters = async (year: number) => {
  const endpoint = `https://gle1g0l5gh.execute-api.us-west-2.amazonaws.com/dev/${year}`
  const response = await fetch(endpoint, {
    method: 'GET',
  })

  return response.json();
}

export const getAvailableModelsForFilters = async (year: number, make: string) => {
  const endpoint = `https://gle1g0l5gh.execute-api.us-west-2.amazonaws.com/dev/${year}/${make}`
  const response = await fetch(endpoint, {
    method: 'GET',
  })

  return response.json();
}

export const getAvailableTrimsForModel = async (year: number, make: string, model: string) => {
  const endpoint = `https://gle1g0l5gh.execute-api.us-west-2.amazonaws.com/dev/${year}/${make}/${model}`
  const response = await fetch(endpoint, {
    method: 'GET',
  })

  return response.json();
}
